import React, { FC, useState } from 'react';

import { LandscapeProjectsAddProjectsAddContactPersonTemplate } from '../../templates';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityType } from '../../../store/landscapeAPI/landscape/entity-type';
import { LandscapeContactPersonResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-contact-person-response.dto';
import { getUUID } from '../../../utils/UUID';
import { LandscapeContactPersonSaveRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-contact-person-save-request.dto';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { saveLandscapeContactPerson } from '../../../store/landscapeAPI/landscape/reducers/landscape-contact-person.slice';

interface LandscapeProjectsAddProjectsAddContactPersonPageProps {}

const LandscapeProjectsAddProjectsAddContactPersonPage: FC<
  LandscapeProjectsAddProjectsAddContactPersonPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { id, projectId } = useParams();

  const navigate = useNavigate();

  const [contactPerson, setContactPerson] =
    useState<LandscapeContactPersonResponseDto>({
      name: '',
      role: '',
      emailAddress: '',
      compactId: '',
      entityId: '',
      entityType: EntityType.Project,
      id: getUUID(),
      versionId: 0,
      createdByUserId: '',
      createdOnDateTimeUtc: '',
      language: '',
      published: true,
    });

  const handleOnChange = (contactPerson: LandscapeContactPersonResponseDto) => {
    setContactPerson(contactPerson);
  };

  const handleCancel = () => {
    navigate(
      `/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information`
    );
  };

  const handleSubmit = async () => {
    const request: LandscapeContactPersonSaveRequestDto = {
      compactId: id!,
      emailAddress: contactPerson.emailAddress,
      entityId: projectId!,
      entityType: EntityType.Project,
      id: getUUID(),
      name: contactPerson.name,
      published: true,
      role: contactPerson.role,
    };

    await dispatch(saveLandscapeContactPerson(request));

    navigate(
      `/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information`
    );
  };

  return (
    <LandscapeProjectsAddProjectsAddContactPersonTemplate
      handleOnChange={handleOnChange}
      contactPerson={contactPerson}
      callbackFn={handleSubmit}
      handleCancel={handleCancel}
    />
  );
};

export default LandscapeProjectsAddProjectsAddContactPersonPage;
